import { Link } from "@tanstack/react-router"
import { LogoMark } from "./logo"

export function NotFound({
  message = "This page doesn't exist, or you don't have access to it.",
}: {
  message?: string
}) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center">
      <LogoMark />
      <p className="max-w-sm text-muted">{message}</p>
      <Link to="/" className="text-sm font-semibold">
        Back to your workspaces
      </Link>
    </main>
  )
}
